import { useAdminUI } from "@/shared/config/admin";
import { pointsHistoryOpen } from "@/shared/config/pointsHistory";
import { useUser } from "@/shared/lib/hooks/useUser/useUser";

const storedEmail = (): string => {
    try {
        return localStorage.getItem("site_user_email") || "";
    } catch {
        return "";
    }
};

/**
 * Видна ли «История баллов» (POINTS_HISTORY_FOR): «all» — всем вошедшим,
 * «admins» — администраторам с учётом «смотреть как пользователь». loading —
 * список администраторов ещё не пришёл (при «all» не важен).
 */
export const usePointsHistoryShown = (): { shown: boolean; loading: boolean } => {
    const { user } = useUser();
    const email = (typeof user === "object" && user?.email) || storedEmail();
    const { isAdmin, loading } = useAdminUI(email);
    const shown = pointsHistoryOpen(isAdmin);
    return { shown, loading: !shown && loading };
};
